export const baseUrl="https://fakestoreapi.com"